<template>
   <div class="maintenance-container">
        <div class="logo">&nbsp;</div>

        <p class="title">{{$t('MAINTENANCETITLE')}}</p>
        <p class="description">{{$t('MAINTENANCEDESCRIPTION')}}</p>

        <div class="maintenance-products">
            <div class="product" v-if="verticalsAvailable.prematch && !maintenance.prematch">
                <router-link :to="{ name: 'sport' }">
                    <div class="dark-overlay">&nbsp;</div>
                    <img src="../../assets/img/maintenance-sport.jpg">
                    <p>{{ $t('SPORTBETTING') }}</p>
                </router-link>
            </div>
            <div class="product" v-if="verticalsAvailable.live && !maintenance.live">
                <router-link :to="{ name: 'live' }">
                    <div class="dark-overlay">&nbsp;</div>
                    <img src="../../assets/img/maintenance-live.jpg">
                    <p>{{ $t('LIVEBETTING') }}</p>
                </router-link>
            </div>
            <div class="product" v-if="verticalsAvailable.lotto && !maintenance.lotto">
                <router-link :to="{ name: 'lotto' }">
                    <div class="dark-overlay">&nbsp;</div>
                    <img src="../../assets/img/maintenance-lotto.jpg">
                    <p>{{ $t('LOTTOBETTING') }}</p>
                </router-link>
            </div>
            <div class="product" v-if="verticalsAvailable.vhorse && !maintenance.vhorse">
                <router-link :to="{ name: 'horses' }">
                    <div class="dark-overlay">&nbsp;</div>
                    <img src="../../assets/img/maintenance-horses.jpg">
                    <p>{{ $t('HORSESBETTING') }}</p>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapGetters,
}
from 'vuex';

export default {
    name: 'Maintenance',
    data()
    {
        return {
        };
    },
    created()
    {
        this.checkMaintenance();
    },
    methods:
    {
        checkMaintenance()
        {
            let hasMaintenancePages = false;

            for (const vertical in this.maintenance)
            {
                if (this.maintenance[vertical] && this.verticalsAvailable[vertical])
                {
                    hasMaintenancePages = true;
                    break;
                }
            }

            if (!hasMaintenancePages && Object.keys(this.maintenance).length)
            {
                this.$router.push({ name: 'REDIRECT' });
            }
        },
    },
    watch:
    {
        maintenance()
        {
            this.checkMaintenance();
        },
    },
    computed:
    {
        ...mapGetters([
            'maintenance',
            'verticalsAvailable',
        ]),
    },
};
</script>
